import { forwardRef, useId, type InputHTMLAttributes, type ReactNode, type SelectHTMLAttributes } from 'react';

interface FeldRahmen {
  label: string;
  fehler?: string;
  hilfe?: ReactNode;
}

export const Feld = forwardRef<HTMLInputElement, FeldRahmen & InputHTMLAttributes<HTMLInputElement>>(function Feld(
  { label, fehler, hilfe, id, className, ...rest },
  ref,
) {
  const eigeneId = useId();
  const feldId = id ?? eigeneId;
  const beschreibung = fehler ? `${feldId}-fehler` : hilfe ? `${feldId}-hilfe` : undefined;
  return (
    <div className={['dxl-feld', fehler && 'dxl-feld--fehler', className].filter(Boolean).join(' ')}>
      <label htmlFor={feldId}>{label}</label>
      <input ref={ref} id={feldId} aria-invalid={!!fehler || undefined} aria-describedby={beschreibung} {...rest} />
      {fehler ? (
        <p id={`${feldId}-fehler`} className="dxl-feld__fehler" role="alert">{fehler}</p>
      ) : hilfe ? (
        <p id={`${feldId}-hilfe`} className="dxl-feld__hilfe">{hilfe}</p>
      ) : null}
    </div>
  );
});

export const Auswahl = forwardRef<HTMLSelectElement, FeldRahmen & SelectHTMLAttributes<HTMLSelectElement>>(function Auswahl(
  { label, fehler, hilfe, id, className, children, ...rest },
  ref,
) {
  const eigeneId = useId();
  const feldId = id ?? eigeneId;
  return (
    <div className={['dxl-feld', fehler && 'dxl-feld--fehler', className].filter(Boolean).join(' ')}>
      <label htmlFor={feldId}>{label}</label>
      <select ref={ref} id={feldId} aria-invalid={!!fehler || undefined} {...rest}>
        {children}
      </select>
      {fehler ? <p className="dxl-feld__fehler" role="alert">{fehler}</p> : hilfe ? <p className="dxl-feld__hilfe">{hilfe}</p> : null}
    </div>
  );
});
